import React from 'react';
import clsx from 'clsx';
import { LuRefreshCw } from 'react-icons/lu';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
}

export const Spinner = ({ size = 'md' }: SpinnerProps) => (
  <LuRefreshCw
    className={clsx(
      'animate-spin',
      size === 'sm' && 'w-4 h-4',
      size === 'md' && 'w-6 h-6',
      size === 'lg' && 'w-8 h-8',
      size === 'xl' && 'w-12 h-12',
      size === '2xl' && 'w-18 h-18',
      size === '3xl' && 'w-28 h-28',
    )}
  />
);
